<template>
  <div>
    <!------------ start toast / snackbar ----------------->
    <error-toast-component :ErrorToast="ErrorToast" @close="close" />
    <!------------ close toast / snackbar ----------------->
    <!------------ heading and buttons------->
    <v-row class="d-flex justify-space-between" flat>
      <v-col cols="12" md="4" class="pt-1">
        <h1 class="heading-1">Forum</h1>
      </v-col>
      <v-col cols="12" md="4">
        <div class="d-flex justify-end">
          <v-card flat class="d-flex align-center">
            <v-dialog v-model="organizedialog" persistent max-width="700">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" outlined dark @click="organizeApiCalls()" v-bind="attrs" v-on="on"
                  class="text_style mr-3 px-9" v-if="Permission.Add">
                  Organize
                </v-btn>
              </template>
              <v-card>
                <div class="mx-5 py-5 d-flex justify-space-between">
                  <div class="d-flex align-center">
                    <span class="h5 mb-1">Organize</span>
                    <v-dialog v-model="newcategorydialog" persistent max-width="450">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn color="primary" text dark v-bind="attrs" v-on="on" class="text_style">
                          + Create Subcategory
                        </v-btn>
                      </template>
                      <v-card>
                        <div class="px-8 pt-5 d-flex justify-space-between">
                          <h5 class="text_style">New Subcategory</h5>
                          <v-icon @click="closeSubCategoryDialog()">mdi-close</v-icon>
                        </div>

                        <v-card color="#F6F8FC" flat class="py-5 px-8">
                          <v-autocomplete :error-messages="$v.Subcategory.category.$error
                            ? 'Category is required'
                            : null
                            " :items="GetForumCategories" item-text="Name" item-value="Id" label="Select Category"
                            attach v-model="Subcategory.category"></v-autocomplete>
                          <v-text-field :error-messages="$v.Subcategory.name.$error
                            ? 'Name is required'
                            : null
                            " v-model="Subcategory.name" label="Name Subcategory" attach></v-text-field>
                          <v-autocomplete :error-messages="$v.Subcategory.permissions.$error
                            ? 'User Level Permissions are required'
                            : null
                            " :items="getMembership" item-text="Name" item-value="Id" label=" User Level Permissions"
                            attach v-model="Subcategory.permissions" multiple></v-autocomplete>
                          <v-autocomplete v-model="Subcategory.course" :items="GetCoursesIDsAndTitle" item-text="Title"
                            item-value="Id" label="Course Permissions" attach multiple></v-autocomplete>
                          <v-autocomplete :items="credentailsitems" v-model="Subcategory.instructor"
                            label=" Instructor Credential Permissions" attach multiple></v-autocomplete>

                          <v-card class="absolute__deleteBtn" v-for="(user, index) in AssignedUsers" :key="index"
                            color="transparent" flat>
                            <v-autocomplete :clearable="index === 0" :items="GetAllInstructorsIDsAndNames"
                              item-text="Name" item-value="Id" label="Assign Individual User"
                              v-model="AssignedUsers[index]" />
                            <v-icon v-if="index !== 0" color="red" @click="removeAnotherField(index)">
                              mdi-delete</v-icon>
                          </v-card>

                          <v-btn @click="addAnotherField()" color="primary" text style="text-transform: none">+Add
                            Another
                          </v-btn>
                          <h5 class="">File</h5>
                          <div class="d-flex align-center">
                            <v-btn class="text_style mb-4 px-8" color="primary" outlined
                              @click="onButtonClickThumbnail">Upload
                              Default</v-btn>
                            <input ref="uploader1" class="d-none" type="file" @change="onFileChangedThumbnail" />
                            <div class="d-flex align-center ml-4" style="height: 100%">
                              <v-chip color="primary" class="mt-n4" @click:close="closechip()" v-show="chip2" close
                                outlined pill>
                                {{ Subcategory.UploadedThumbnail }}
                              </v-chip>
                              <p style="color: #8080808f" v-if="!chip2">
                                (400 x 200 px)
                              </p>
                            </div>
                          </div>
                        </v-card>
                        <v-card-actions class="pb-4 mx-3">
                          <v-spacer></v-spacer>
                          <v-btn class="px-14 py-6 text_style" color="grey lighten-1" text
                            @click="closeSubCategoryDialog()">
                            Cancel
                          </v-btn>
                          <v-btn :disabled="btnloader" color="primary" class="px-14 py-6 text_style"
                            @click="AddNewSubcategory()">
                            <v-progress-circular indeterminate size="20" class="px-5" color="white"
                              v-if="btnloader"></v-progress-circular>
                            <span v-else>Save</span>
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </div>
                  <v-icon @click="organizedialog = false">mdi-close</v-icon>
                </div>

                <organizeformcomponet v-if="organizedialog" @GetForumCategories="callApiSubcategory" />

                <v-card-actions class="pb-7">
                  <v-spacer></v-spacer>

                  <v-btn color="primary" class="px-14 py-6 text_style" @click="organizedialog = false">
                    <span class="pa-4">Close</span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card>
          <v-card flat class="d-flex align-center">
            <v-dialog v-model="add_dialog" persistent width="950" style="overflow-y: hidden">
              <template v-slot:activator="{ on, attrs }">
                <v-btn depressed color="primary" dark v-bind="attrs" v-on="on" class="text_style" v-if="Permission.Add">
                  + Add new Post
                </v-btn>
              </template>
              <v-card>
                <div class="mx-8 py-5 d-flex justify-space-between">
                  <div>
                    <h3><b>Create a post</b></h3>
                  </div>
                  <div class="d-flex align-center">
                    <v-icon @click="add_dialog = false">mdi-close</v-icon>
                  </div>
                </div>
                <createforum-component v-if="add_dialog" :add_dialog="add_dialog" @close="close" @savePost="
                  fetchData(), showSuccessToast('Added Post Successfully')
                  " />
              </v-card>
            </v-dialog>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <!------------ search and filter------->
    <div class="my-3">
      <v-row class="mt-6">
        <v-col cols="12" md="4" sm="6">
          <v-card flat>
            <v-text-field dense outlined prepend-inner-icon="mdi-magnify" label="search" v-model="search" hide-details
              single->
              <!-- @input="searchData()" -->
            </v-text-field>
          </v-card>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <v-card height="45" outlined class="px-2 mt-n1 d-flex justify-start align-center" style="cursor: pointer"
            @click="filterApiCalls()">
            <div class="d-flex justify-space-between align-center" style="width: 100%">
              <div>
                <v-icon>mdi-tune</v-icon>
                <span class="text_style mx-1" style="letter-spacing: 1px">Filters</span>
              </div>

              <div>
                <v-icon>mdi-menu-down</v-icon>
              </div>
            </div>
          </v-card>
          <!------------------------fliter diloag------------------------------------------>
          <v-dialog v-model="filterDialog" max-width="430" persistent>
            <v-card class="py-5">
              <v-card-title class="mb-5 d-flex justify-space-between align-center">
                <div class="text-h5"><b> Filters</b></div>
                <div>
                  <v-btn text depressed class="pa-0" @click="cleanFilter()">
                    <span class="text_style primary--text" style="letter-spacing: 0px">Clean filters</span>
                  </v-btn>
                  <v-icon class="ml-3" @click="filterDialog = false">mdi-close</v-icon>
                </div>
              </v-card-title>
              <v-card-text>
                <v-select outlined v-model="filterObj.Categories" :items="GetForumCategories" item-text="Name"
                  item-value="Id" dense hide-details label="By Category" multiple persistent-hint
                  :menu-props="{ maxHeight: '400' }" clearable></v-select>
                <v-select outlined class="my-5" item-text="SubCategoryName" item-value="Id"
                  v-model="filterObj.Subcategories" :items="Subcategories" dense :menu-props="{ maxHeight: '400' }"
                  hide-details :disabled="filterObj.Categories.length === 0" label="By Subcategory" multiple
                  persistent-hint clearable></v-select>
                <v-menu ref="datarangemenu" v-model="datarangemenu" :close-on-content-click="false"
                  :return-value.sync="Renewaldates" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="filterObj.dates" label="Date Created" prepend-inner-icon="mdi-calendar"
                      readonly dense outlined v-bind="attrs" v-on="on" clearable></v-text-field>
                  </template>
                  <v-date-picker v-model="Renewaldates" no-title scrollable range>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="datarangemenu = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="$refs.datarangemenu.save(Renewaldates)">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
                <!-----------------------READ it--------------------------->
                <!-----------------------------Submitted by which needs to be a search field to search Users-------------------------------->
                <v-select outlined v-model="filterObj.SubmittedBy" :items="GetForumByFilter" item-text="Name"
                  item-value="Id" dense :menu-props="{ maxHeight: '400' }" hide-details label="Submitted by" multiple
                  persistent-hint clearable></v-select>
                <!-----------------------READ comment--------------------------->
                <v-select outlined class="my-5" v-model="filterObj.ByComment" :items="filterformatList"
                  :menu-props="{ maxHeight: '400' }" dense hide-details label="New Comments" persistent-hint
                  clearable></v-select>
                <v-select outlined v-model="filterObj.Pinned" :items="filterpushpinlist" dense
                  :menu-props="{ maxHeight: '400' }" hide-details label="Pinned" persistent-hint clearable></v-select>
                <v-select class="my-5" outlined v-model="filterObj.MostViews" :items="filterviewslist" dense
                  :menu-props="{ maxHeight: '400' }" hide-details label="Most Following" persistent-hint
                  clearable></v-select>

                <!---------------------Type-modalitiy model filter-------------------------------->
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#646464" outlined depressed class="px-5" text @click="filterDialog = false">
                  <span class="text_style"> Cancel </span>
                </v-btn>
                <v-btn color="primary" class="px-8 ml-2" @click="sendFilters()" depressed>
                  <span class="text_style"> Save Filters </span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </div>

    <v-dialog v-model="Edit_dialog" persistent width="950" style="overflow-y: hidden">
      <v-card>
        <div class="mx-8 py-5 d-flex justify-space-between">
          <div>
            <h3><b>Edit a post</b></h3>
          </div>
          <div class="d-flex align-center">
            <v-icon @click="Edit_dialog = false">mdi-close</v-icon>
          </div>
        </div>
        <editforum-component v-if="Edit_dialog" :editItem="editItem" @close="close"
          @savePost="fetchData(), showSuccessToast('Edited post Successfully')" />
      </v-card>
    </v-dialog>

    <!-- Preview Dialog - Larger Size -->
    <v-dialog v-model="previewDialog" persistent max-width="900" scrollable>
      <v-card class="preview-dialog">
        <v-toolbar color="primary" dark dense flat>
          <v-toolbar-title class="text-h6">Post Preview</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="previewDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-0">
          <PreviewforumComponent 
            v-if="previewDialog && previewItem"
            :previewItem="previewItem"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!------------ data table------>
    <v-card class="mt-6" outlined>
      <v-data-table :headers="headers" :items="GetForum" :loading="tableLoader" hide-default-footer
        loading-text="Loading... Please wait" :items-per-page="displayedItemsPerPage" :page.sync="page"
        @page-count="pageCount = $event">
        <template v-slot:[`item.index`]="{ index }">
          <b>
            {{
              search
                ? index + 1
                : index + displayedItemsPerPage * (page - 1) + 1
            }}
            <!-- {{ index + 1 }} -->
          </b>
        </template>

        <template v-slot:[`item.Title`]="{ item }">
          <span class="table_style_one"> {{ item.Title }} </span>
        </template>
        <template v-slot:[`item.SubmittedByName`]="{ item }">
          <span class="table_style_two"> {{ item.SubmittedByName }} </span>
        </template>
        <template v-slot:[`item.CreatedDate`]="{ item }">
          <span class="table_style_two">
            {{ item.CreatedDate.split("T")[0] }}
          </span>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn icon @click="toggleIsPin(item.Id)" class="ml-5">
            <v-icon v-if="item.Pinned" color="orange">mdi-pin-outline</v-icon>
            <v-icon v-else>mdi-pin-off-outline</v-icon>
          </v-btn>

          <v-btn icon @click="toggleIsPlaying(item.Id)" class="mx-5">
            <v-icon v-if="item.Visibility" color="primary">mdi-eye</v-icon>
            <v-icon v-else>mdi-eye-off</v-icon>
          </v-btn>
          <v-menu transition="scroll-y-transition" offset-y color="transparent">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="A1A1A6" v-bind="attrs" v-on="on">
                mdi-dots-horizontal
              </v-icon>
            </template>
            <v-card flat>
              <!-- <v-list class="px-3 pt-1" color="transparent">
                <div class="d-flex">
                  <v-btn
                    depressed
                    color="transparent"
                    @click="toggleIsPin(item.Id)"
                    block
                    class="d-flex justify-start"
                  >
                    <v-icon color="#646464">mdi-pin-outline</v-icon>
                    <span class="ml-4 text_style">Pin / Unpin</span>
                  </v-btn>
                </div>
              </v-list> -->

              <v-list class="px-3 pt-1" color="transparent">
                <div class="d-flex">
                  <v-btn depressed color="transparent" @click="EditItem(item)" block class="d-flex justify-start">
                    <v-icon color="#646464">mdi-pencil</v-icon>
                    <span class="ml-4 text_style">Edit</span>
                  </v-btn>
                </div>
              </v-list>
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn depressed color="transparent" block @click="showCommentDialog(item)"
                  class="d-flex justify-start">
                  <!-- <v-badge :content="item.countcomment" overlap>
                    <v-icon color="#646464">mdi-message-reply-text</v-icon>
                  </v-badge> -->
                  <v-badge :content="totalForums == 0 ? '0' : totalForums" overlap>
                    <v-icon color="#646464">mdi-message-reply-text</v-icon>
                  </v-badge>

                  <span class="ml-4 text_style">Comments </span>
                </v-btn>
              </v-list>
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn depressed color="transparent" block class="d-flex justify-start" @click="SetPreview(item)">
                  <div>
                    <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M16 16H2V2H9V0H2C0.89 0 0 0.9 0 2V16C0 17.1 0.89 18 2 18H16C17.1 18 18 17.1 18 16V9H16V16ZM11 0V2H14.59L4.76 11.83L6.17 13.24L16 3.41V7H18V0H11Z"
                        fill="#222222" fill-opacity="0.7" />
                    </svg>
                  </div>
                  <span class="ml-4 text_style">Preview Post</span>
                </v-btn>
              </v-list>
              <v-list class="px-3 pt-1" color="transparent" v-if="Permission.Delete">
                <v-btn depressed color="transparent" block class="d-flex justify-start"
                  @click="SetDeleteDialog(item.Id)">
                  <v-icon color="#646464">mdi-delete</v-icon>
                  <span class="ml-4 text_style">Delete</span>
                </v-btn>
              </v-list>
            </v-card>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <!-- <div
      v-if="GetForum.length"
      v-observe-visibility="handleScrolledToBottom"
      class="d-flex justify-center my-4"
    >
      <v-progress-circular
        indeterminate
        size="30"
        class="px-5"
        color="primary"
        v-show="btnloader"
      ></v-progress-circular>
    </div> -->
    <v-card flat class="my-9 d-flex justify-end align-center">
      <span class="text_transform pa-0 ma-0">Per page :</span>
      <v-card flat width="100" class="mx-5">
        <v-select :items="ItemsPerPageItems" label="Items per page" v-model="itemsPerPage"
          @change="handleItemPerPage()"></v-select>
      </v-card>

      <v-pagination v-model="page" :length="pageCount" :total-visible="5" @input="fetchData"></v-pagination>
    </v-card>
    <!---------------Preview post --Dialog----------------------->
    <!-- <v-dialog v-model="previewdialog" persistent max-width="800">
      <v-card>
        <div class="mx-9 py-9 d-flex justify-space-between">
          <h5>Preview Post</h5>
          <v-icon @click="previewdialog = false">mdi-close</v-icon>
        </div>
        <div class="px-9 pb-5" v-if="previewdialog">
          <PreviewForumComponent
            :previewItem="previewItem"
          ></PreviewForumComponent>
        </div>
      </v-card>
    </v-dialog> -->
    <!---------------Delete post --Dialog----------------------->
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style">Are you sure you want to delete?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="DdialogClose">
            Cancel
          </v-btn>
          <v-btn color="primary" :disabled="btnloader" @click="DeleteForum">
            <span v-if="btnloader != true"> confirm </span>
            <v-progress-circular v-else indeterminate size="20" class="px-5" color="white"
              v-show="btnloader"></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editForumDialog" persistent max-width="290">
      <v-card>
        <div class="d-flex justify-center py-10 primary">
          <v-progress-circular indeterminate size="40" class="px-5" color="white"></v-progress-circular>
        </div>
      </v-card>
      <div class="white py-2 px-2 d-flex justify-end">
        <v-btn color="green darken-1" text @click="cancelEdit"> Cancel </v-btn>
      </div>
    </v-dialog>
    <v-dialog v-model="commentdialog" max-width="608" content-class="elevation-0">
      <v-card flat>
        <formcomments v-if="commentdialog" @close="close" :commentarray="commentarray" :totalForums="totalForums"
          @callApi="commentsection(commentarray)" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import formcomments from "../../components/Forum/formcomments.vue";
import CreateforumComponent from "../../components/Forum/createforum.component.vue";
// import PreviewForumComponent from "../../components/Forum/previewforum.component.vue";
import ErrorToastComponent from "../../components/Toast/ErrorToast.component.vue";
import organizeformcomponet from "../../components/Forum/organizeformcomponet.vue";
import { mapGetters } from "vuex";
import Formcomments from "../../components/Forum/formcomments.vue";
import EditforumComponent from "../../components/Forum/editforum.component.vue";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import PreviewforumComponent from "../../components/Forum/previewforum.component.vue";
export default {
  components: {
    formcomments,
    organizeformcomponet,
    CreateforumComponent,
    ErrorToastComponent,
    Formcomments,
    EditforumComponent,
    PreviewforumComponent
    //PreviewForumComponent,
  },
  data() {
    return {
      courseIdAndTitle: [],
      chip2: false,
      searchTimer: 0,
      totalForums: null,
      commentarray: [],
      Subcategory: {},
      commentdialog: false,
      datarangemenu: false,
      dates: [],
      filterviews: [],
      filterviewslist: ["Yes", "No"],
      filterpushpinlist: ["Yes", "No"],
      filterformatList: ["Yes", "No"],
      InstructorsArray: [],
      coursePrerequisiteArray: [],
      editItem: null,
      ItemsPerPageItems: [10, 50, 100, 200],
      page: 1,
      Renewaldates: [],
      pageCount: 1,
      itemsPerPage: 10,
      Permission: {},
      ErrorToast: false,
      DeleteId: 0,
      previewdialog: false,
      previewDialog: false,
      previewItem: {},
      isHidden: false,
      add_dialog: false,
      Edit_dialog: false,
      organizedialog: false,
      newcategorydialog: false,
      tableLoader: false, // data-table true or false
      dialog: false,
      editForumDialog: false,
      btnloader: false,
      isPlaying: false,
      search: "",
      selectedRowData: {},
      filter: "",
      selectedFile: null,
      Visibility: false,
      filterDialog: false,
      filtersubCategory: [],
      filterpushpin: [],
      filterformat: [],
      filteruser: [],
      filterCategory: [],
      filtersubcategory: [],
      filtersubCategoryList: [],
      credentailsitems: ["BAT", "CBI", "SrCBI", "CBI-A", "BrI", "MSI", "FFI"],
      AssignedUsers: [""],
      headers: [
        { text: "#", value: "index", sortable: false },
        { text: "Post Title", value: "Title" },
        { text: "Date created", value: "CreatedDate" },
        { text: "Submitted by", value: "SubmittedByName" },
        { text: "Category", value: "CategoryName" },
        { text: "Subcategory", value: "SubCategoryName" },
        { text: "Following", value: "Followers", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
      filterObj: {
        Categories: [],
        Subcategories: [],
        SubmittedBy: [],
        ByComment: "",
        Pinned: "",
        MostViews: "",
        dates: "",
      },
      filtersArray: [
        {
          Key: "Type",
          Value: "admin",
        },
      ],
      forums: [],
      searching: false,
    };
  },
  validations: {
    Subcategory: {
      category: { required },
      name: { required },
      permissions: {
        required: function () {
          return this.requireUserPermissions;
        },
      },
    },
  },

  computed: {
    ...mapGetters([
      "GetUserRolePermissions",
      "GetCoursesIDsAndTitle",
      "getMembership",
      "GetAllInstructorsIDsAndNames",
      "GetForum",
      "GetTotalForumsComment",
      "GetForumByFilter",
      "GetForumCategories",
      "GetLoggedInUser",
      "GetForumById",
    ]),
    dateRangeText() {
      let firstDate = this.Renewaldates[0];
      let lastDate = this.Renewaldates[1];
      let formatDate =
        moment(firstDate).format("YYYY-MM-DD") +
        " to " +
        moment(lastDate).format("YYYY-MM-DD");
      return formatDate;
    },
    requireUserPermissions() {
      if (this.Subcategory?.permissions?.length > 0) {
        return true;
      } else {
        // Check if any user is assigned; if not, require user-level permissions
        return this.AssignedUsers.every(user => user);
      }
    },
    displayedItemsPerPage() {
      return this.itemsPerPage === "All"
        ? this.GetForum.length
        : this.itemsPerPage;
    },
    Subcategories() {
      let arr = [];
      if (this.filterObj.Categories?.length > 0) {
        const list = this.GetForumCategories.filter((category) =>
          this.filterObj.Categories.includes(category.Id)
        );
        list.forEach((item) => {
          arr = arr.concat(item.Subcategories);
        });
      }
      return arr;
    },
  },

  mounted() {
    this.fetchData();
    // this.GetCoursesArray();
    // this.GetInstructorArray();
    this.GetForumCategoriesArray();
    // this.getFilterByUser();
    this.$store.dispatch("getMembership");
    this.Permission = this.GetUserRolePermissions.RolePermissions.find(
      (x) => x.Module === "Forum"
    );
  },
  methods: {
    filterApiCalls() {
      this.getFilterByUser();
      this.filterDialog = true;
    },
    organizeApiCalls() {
      this.GetCoursesArray();
      this.GetInstructorArray();
    },
    handleScrolledToBottom(isVisibility) {
      if (!isVisibility) return;
      this.page++;
      if (this.pageCount < this.page) return;
      this.btnloader = this.page == 1 ? false : true;
      this.fetchData();
    },
    isDateGreaterThanCurrent(dateStr) {
      var currentDate = new Date();
      var givenDate = new Date(dateStr);

      // Extract year, month, and day from the current date
      var currentYear = currentDate.getFullYear();
      var currentMonth = currentDate.getMonth() + 1; // Months are 0 indexed
      var currentDay = currentDate.getDate();

      // Extract year, month, and day from the given date
      var givenYear = givenDate.getFullYear();
      var givenMonth = givenDate.getMonth() + 1; // Months are 0 indexed
      var givenDay = givenDate.getDate();

      // Compare years
      if (givenYear > currentYear) {
        return true;
      } else if (givenYear < currentYear) {
        return false;
      }

      // If years are the same, compare months
      if (givenMonth > currentMonth) {
        return true;
      } else if (givenMonth < currentMonth) {
        return false;
      }

      // If months are the same, compare days
      if (givenDay > currentDay) {
        return true;
      } else {
        return false;
      }
    },
    getFilterByUser() {
      // const obj = {
      //   page: 1,
      //   pageSize: 50000,
      //   search: "",
      //   filters: "",
      // };
      this.$store.dispatch("GetForumByFilter");
    },
    handleItemPerPage() {
      if (this.page !== 1) {
        this.page = 1;
      }
      this.fetchData();
    },
    closechip() {
      this.chip2 = false;
    },
    onButtonClickThumbnail() {
      this.$refs.uploader1.click();
    },
    onFileChangedThumbnail(e) {
      this.chip2 = true;
      this.Subcategory.Thumbnail = e.target.files[0];
      this.selectedFile = e.target.files[0];
      this.Subcategory.UploadedThumbnail =
        this.Subcategory.Thumbnail.name.substring(0, 20);
      this.$refs.uploader1.value = null;
    },
    sendFilters() {
      this.page = 1;
      this.filtersArray = [
        {
          Key: "Type",
          Value: "admin",
        },
      ];
      if (this.filterObj.Categories.length > 0) {
        this.filtersArray.push({
          Key: "Categories",
          Value: this.filterObj.Categories.join(","),
        });
      }
      if (this.filterObj.Subcategories.length > 0) {
        this.filtersArray.push({
          Key: "Subcategories",
          Value: this.filterObj.Subcategories.join(","),
        });
      }
      if (this.filterObj.dates) {
        this.filtersArray.push({
          Key: "ByCreatedDate",
          Value: this.filterObj.dates,
        });
      }
      if (this.filterObj.SubmittedBy.length > 0) {
        this.filtersArray.push({
          Key: "SubmittedBy",
          Value: this.filterObj.SubmittedBy.join(","),
        });
      }
      if (this.filterObj.ByComment && this.filterObj.ByComment === "Yes") {
        this.filtersArray.push({
          Key: "ByComment",
          Value: this.filterObj.ByComment,
        });
      }
      if (this.filterObj.Pinned && this.filterObj.Pinned === "Yes") {
        this.filtersArray.push({
          Key: "Pinned",
          Value: this.filterObj.Pinned,
        });
      }
      if (this.filterObj.MostViews) {
        this.filtersArray.push({
          Key: "Followers",
          Value: this.filterObj.MostViews,
        });
      }

      this.fetchData(1);
      this.filterDialog = false;
    },
    GetForumCategoriesArray() {
      this.$store.dispatch("GetForumCategories");
    },
    GetCoursesArray() {
      const obj = {
        page: 1,
        pageSize: "All",
        search: "",
        filters: "",
      };
      this.$store.dispatch("GetCoursesIDsAndTitle", obj).then(() => {
        this.courseIdAndTitle = this.GetCoursesIDsAndTitle;
        if (this.courseIdAndTitle?.length > 0) {
          this.courseIdAndTitle = this.courseIdAndTitle.filter((value) => {
            return value.Visibility === true
          })
        }
      })
    },
    GetInstructorArray() {
      this.$store.dispatch("GetAllInstructorsIDsAndNames")
    },

    cleanFilter() {
      this.filterObj = {
        Categories: [],
        Subcategories: [],
        SubmittedBy: "",
        ByComment: "",
        Pinned: "",
        MostViews: "",
        dates: "",
      };
    },
    SetDeleteDialog(id) {
      this.dialog = true;
      this.DeleteId = id;
    },
    DeleteForum() {
      this.btnloader = true;
      this.$store.dispatch("DeleteForum", this.DeleteId).then(() => {
        this.dialog = false;
        this.btnloader = false;
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Deleted Successfully",
          showConfirmButton: false,
          timer: 1500,
        });
        this.fetchData();
      });
    },
    callApiSubcategory(message) {
      this.GetForumCategoriesArray();
      this.showSuccessToast(message);
    },
    SetPreview(item) {
      console.log("🚀 ~ SetPreview ~ item:", item)
      this.previewItem = JSON.parse(JSON.stringify(item)); // Deep copy;
      this.previewDialog = true;
      // this.$store.dispatch("GetPreview", item);
    },
    toggleIsPin(obj) {
      this.$store.dispatch("TogglePin", obj).then(() => {
        this.fetchData();
      });
    },
    toggleIsPlaying(obj) {
      this.$store.dispatch("ToggleVisiblity", obj).then(() => {
        this.fetchData();
      });
    },
    commentsection(item) {
      this.commentarray = item;
      const obj = {
        page: 1,
        pageSize: "All",
        forumId: item.Id,
      };
      this.$store.dispatch("GetForumComments", obj).then((res) => {
        this.totalForums = res.totalRecords;
      });
    },
    showCommentDialog(item) {
      this.commentarray = item;
      const obj = {
        page: 1,
        pageSize: "All",
        forumId: item.Id,
      };
      this.$store.dispatch("GetForumComments", obj).then((res) => {
        this.totalForums = res.totalRecords;
        this.commentdialog = true;
      });
    },
    EditItem(item) {
      let forumId = item.Id;
      // Dispatch the action to get forum data by ID
      this.editForumDialog = true;
      this.$store
        .dispatch("GetForumById", forumId)
        .then((res) => {
          this.editItem = res;
          this.editForumDialog = false;
          this.Edit_dialog = true;
        })
        .catch((error) => {
          console.error("Error fetching forum data:", error);
        });
    },
    cancelEdit() {
      this.editForumDialog = false;
    },
    DdialogClose() {
      this.dialog = false;
    },
    closeSubCategoryDialog() {
      this.chip2 = false;
      this.newcategorydialog = false;
      this.Subcategory = {};
      this.AssignedUsers = [""];
      this.$v.Subcategory.$reset();
      this.$v.AssignedUsers.$reset();
    },
    AddNewSubcategory() {
      this.$v.Subcategory.$touch();
      if (this.$v.Subcategory.$invalid) {
        return;
      } else {
        const Courses = this.Subcategory.course;
        const PermissionId = this.Subcategory.permissions;
        const InstructorCredentials = this.Subcategory.instructor;
        const AssignedUsers = this.AssignedUsers.filter(
          (item) => item !== ""
        ).join();
        const payload = {
          CategoryId: this.Subcategory.category,
          SubCategoryName: this.Subcategory.name,
          Courses: Courses ? Courses.join() : "",
          PermissionId: PermissionId ? PermissionId.join() : "",
          InstructorCredentials: InstructorCredentials
            ? InstructorCredentials.join()
            : "",
          AssignedUsers: AssignedUsers,
          SubmittedBy: this.GetLoggedInUser.Id,
          File: this.selectedFile,
        };
        const formData = new FormData();
        formData.append("CategoryId", payload.CategoryId);
        formData.append("SubCategoryName", payload.SubCategoryName);
        formData.append("Courses", payload.Courses);
        formData.append("SubmittedBy", payload.SubmittedBy);
        formData.append("PermissionId", payload.PermissionId);
        formData.append("InstructorCredentials", payload.InstructorCredentials);
        formData.append("AssignedUsers", payload.AssignedUsers);
        formData.append("File", payload.File);
        this.btnloader = true;
        this.$store
          .dispatch("AddSubCategory", formData)
          .then((res) => {
            if (res.Status) {
              this.showSuccessToast("Added Subcategory Successfully");
              this.GetForumCategoriesArray();
              this.closeSubCategoryDialog();
            } else {
              this.$swal.fire({
                toast: true,
                position: "top-end",
                icon: "error",
                title: res.Message,
                showConfirmButton: false,
                timer: 3000,
              });
              this.btnloader = false;
            }
          })
          .catch(() => {
            this.btnloader = false;
          });
      }
    },
    close() {
      this.ErrorToast = false;
      this.add_dialog = false;
      this.Edit_dialog = false;
      this.commentdialog = false;
    },
    searchData() {
      this.page = 1;
      this.fetchData();
    },
    fetchData(page) {
      const obj = {
        page: page ?? this.page,
        pageSize: this.itemsPerPage === "All" ? -1 : this.itemsPerPage,
        search: this.search,
        filters: JSON.stringify(this.filtersArray),
      };
      this.tableLoader = true;
      this.$store.dispatch("GetForum", obj).then((res) => {
        // this.forums.push(...res.List);
        this.btnloader = false;
        this.tableLoader = false;
        if (this.itemsPerPage !== "All") {
          this.pageCount = Math.ceil(res.totalRecords / this.itemsPerPage);
        } else {
          this.pageCount = 1;
        }
      });
    },
    showSuccessToast(message) {
      this.$swal.fire({
        toast: true,
        position: "top-end",
        icon: message.includes("Deleted") ? "warning" : "success",
        title: message,
        showConfirmButton: false,
        timer: 1500,
      });
    },
    addAnotherField() {
      this.AssignedUsers.push("");
    },
    removeAnotherField(index) {
      this.AssignedUsers.splice(index, 1);
    },
  },
  watch: {
    dateRangeText() {
      this.filterObj.dates = this.dateRangeText;
    },
    search() {
      // if(pre !== cur){
      //   this.page = 0
      //   this.forums = []
      // }
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.fetchData();
      }, 700);
    },
  },
};
</script>
<style scoped lang="scss">
.preview-dialog {
  max-height: 85vh;
  display: flex;
  flex-direction: column;
}

.v-card__text {
  overflow-y: auto;
  padding: 0;
}

.v-text-field--outlined>>>fieldset {
  border-color: #e0e0e0;
}
</style>
